import React from 'react';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListSchema from './submodules/list';
import CreateSchmea from './submodules/create';
import EditSchema from './submodules/edit';
import UploadSchema from './submodules/uploadCsv';

const MttSchemaDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.mttSchema}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].getMttSchema]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListSchema}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.mttSchema}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].createMttSchema]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateSchmea}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.mttSchema}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].updateMttSchema]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditSchema}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.mttSchema}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.mttSchema].uploadCsv]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/uploadCsv`}
				component={UploadSchema}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default MttSchemaDashboard;
